module.exports = __webpack_public_path__ + "img/Terraform-6.42f03300.png";